var common = require("../../utiles/common.js")
var service = require("../../utiles/service")

module.exports = {
    register: function () {
        //工作流列表
        document.createElement('work-applist')
        ko.components.register('work-applist', {
            viewModel: function (params) {
                var $this = this;
                var param = {pageNumber:1,pageSize:10};
                var workType = location.hash.replace("#/workflow/", "").split('/')[0];
                $this.workType = workType;
                console.log(workType)
                $this.checked = ko.observable(false);
                $this.enable = ko.observable(false);
                $this.isMask = ko.observable();
                $this.selectNum = ko.observable(0);
                $this.total = ko.observable(0);
                $this.dataList = ko.observableArray();
                //分页初始化
                $this.initPage = function(listObject){
                    $(".zxf_pagediv").createPage({
                        total:listObject.totalNumber,
                        pageNum: listObject.totalPage,
                        current: listObject.pageNumber,
                        backfun: function(e) {
                            param.pageNumber = e.current;
                            switch(workType){
                                case "pending":
                                result = service.workflow.getNeedMyRatifyWorkflow(param);
                                break;
                                case "approved":
                                result = service.workflow.getMyRatifyFinishedWorkflow(param);
                                break;
                                case "Initiator":
                                result = service.workflow.getMySubmitWorkflow(param);
                                break;
                                case "complete":
                                result = service.workflow.getMySubmitWorkflowAndFinished(param);
                                break;
                            }
                            $this.total(result.totalNumber);
                            $this.dataList(result.data);
                            $this.initPage(result);
                        }
                    });
                }

                var result = "";
                //初始化
                $this.initList = function(){
                    switch(workType){
                        case "pending":
                        result = service.workflow.getNeedMyRatifyWorkflow(param);
                        break;
                        case "approved":
                        result = service.workflow.getMyRatifyFinishedWorkflow(param);
                        break;
                        case "Initiator":
                        result = service.workflow.getMySubmitWorkflow(param);
                        break;
                        case "complete":
                        result = service.workflow.getMySubmitWorkflowAndFinished(param);
                        break;
                    }
                    $this.total(result.totalNumber);
                    $this.dataList(result.data);
                    $this.initPage(result);
                    console.log(result)
                }
                $this.initList();

                //复选框点击---全选
                $this.checkChange = function(){
                    $this.checked(!$this.checked());
                    $this.enable($this.checked());
                    if($this.checked()){
                        $this.selectNum(10);
                    }else{
                        $this.selectNum(0);
                    }
                }

                //回选
                $this.checkAll = function(checked){
                    console.log(checked);
                    $this.checked(checked);
                    $this.selectNum($(".table_body input:checkbox:checked").length);
                }

                //打开审批弹窗
                $this.openBatch = function(k){
                    if($this.selectNum()>0){
                        $this.isMask(k);
                    }else{
                        common.message("error","请先选择审批项!");
                    }
                }

                //批量处理---审批-驳回
                $this.batch = function(type){
                    var values = [];
                    var result = "";
                    var checks = $(".table_body input:checkbox:checked");
                    for(var i=0;i<checks.length;i++){
                        values.push(checks[i].value);
                    }
                    console.log(values)
                    var param = {
                        taskIds:values,
                    }
                    switch(type){
                        case "Approval":
                        param.approve = true;
                        result = service.workflow.completeBatch(param);
                        break;
                        case "Reject":
                        var paramForm = $.extend({},$('.work_mask textarea').serializeObject());
                        if(!paramForm.reason){
                            common.message("error","请填写拒绝理由!");
                            return false;
                        }
                        param.approve = false;
                        param.reason = paramForm.reason;
                        result = service.workflow.completeBatch(param);
                        break;
                    }
                    common.message("success","提交成功");
                    console.log(result)
                    $this.initList();
                    $this.clear();
                }

                $this.clear = function(){
                    $this.isMask("");
                    $this.checked(false);
                    $this.enable(false);
                }
            },
            template: require("./template/WorkApplist.html")
        });
        //工作单条数据处理
        document.createElement('work-item')
        ko.components.register('work-item', {
            viewModel: function (params) {
                var $this = this;
                $this.$data = params.app;
                $this.type = params.type;
                $this.index = params.index;
                $this.enable = params.enable;
                $this.isMask = ko.observable();
                $this.maskType = ko.observable();
                $this.taskId = ko.observable();
                $this.forms = ko.observableArray();
                $this.flows = ko.observableArray();
                // console.log($this.type)

                $this.visible = function(id,key,processInstanceId,appId,type){
                    $this.formItems=[];
                    $this.forms([]);
                    if(key == "ck"){
                        $this.flows(service.workflow.processInfo(processInstanceId));
                        if(type == "ACCOUNTDREDGE"||type == "USERDREDGE"){
                            $this.forms(service.workflow.getAccountInfos(id));
                        }
                    }else{
                       $this.taskId(id);
                    }
                    $this.maskType("history");
                    $this.isMask(key);
                }
                //复选框点击
                $this.checkChange = function(){
                    var notChecks = $(".table_body input:checkbox").not(":checked");
                    if(notChecks.length>0){
                        params.checkChange(false);
                    }else{
                        params.checkChange(true);
                    }
                }

                //切换详情tab
                $this.switchMaskType = function(type){
                    $this.maskType(type);
                }

                //同意--拒绝
                $this.complete = function(approve){
                    var paramForm = {
                        taskId:$this.taskId(),
                        approve:approve
                    }
                    if(approve){
                        service.workflow.complete(paramForm);
                        $this.update();
                    }else{
                        var validationResult = {valid: undefined};
                        console.log($this.formItems)
                        validationResult = common.validateAll($this.formItems);
                        if (validationResult.valid) {
                            paramForm = $.extend(paramForm,$('.work_mask textarea').serializeObject());
                            service.workflow.complete(paramForm);
                            $this.update();
                        }
                    }
                }

                //操作完的处理
                $this.update = function(){
                    params.updateList();
                    $this.visible();
                    common.message("success","提交成功");
                }

                //撤回
                $this.cancel = function(id){
                    service.workflow.cancel(id)
                    $this.update();
                }

                //转换值
                $this.onType = function(type,value){
                    switch(type){
                        case "Boolean":
                        return value?"是":"否";
                        case "DateTime":
                        return common.timestampToTime(value);
                        case "SingleTree":
                        return value.join(",");
                        case "MultiTree":
                        return value.join(",");
                        case "Tag":
                        return value.join(",");
                        case "Password":
                        return "******";
                        default:
                        return value;
                    }
                }

                $this.timestampToTime = function(num){
                    return common.timestampToTime(num,"");
                }
               
            },
            template: require("./template/WorkItem.html")
        });
        //申请表
        document.createElement('app-lication')
        ko.components.register('app-lication', {
            viewModel: function (params) {
                var $this = this;
                $this.type = ko.observable("tobe");
                var appId = location.hash.replace("#/application/", "").split('/')[0];
                var label = location.hash.replace("#/application/", "").split('/')[1];
                $this.formData = [];//service.workflow.startForm(label);

                $this.onType = function(type){
                    switch(type){
                        case "boolean":
                        return "bool";
                        case "date":
                        return "datetime";
                    }
                }

                $this.valid = function(data){
                    for(var i=0;i<data.length;i++){
                        if(data[i].formItems[0].type != "datetime"&&!common.validateAll(data[i].formItems).valid){
                            return false;
                        }
                    }
                    return true;
                }
                
                $this.submit = function(){
                    var datas = {};
                    datas.appId = appId;
                    datas.reason = $('#reason input').val();
                    //datas.formParams = $.extend($('#forms input').serializeObject(),$('#forms textarea').serializeObject(),$('#forms select').serializeObject());
                    var validationResult = common.validateAll($this.formItems);
                    if (validationResult.valid) {
                        if($this.valid($this.formData)){
                            var result = service.workflow.create(datas);
                            if(result.httpStatus == "OK"){
                                common.message("success","申请提交成功");
                                common.redirectTo("/#/accountApply");
                            }
                        }
                    }
                }
            },
            template: require("./template/Application.html")
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/component/workflow/Workflow.js
// module id = 178
// module chunks = 0